import React, {useMemo} from 'react';
import LeafletMarker from "@ui/leafletCustom/leafletMarker/LeafletMarker";
import {DivIcon, LatLng} from 'leaflet';
import LeafletPopup from "@ui/leafletCustom/leafletPopup/LeafletPopup";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {
	getPointSizeByEntryRadiusSingleVoyage
} from '@containers/singleVoyage/containers/points/helpers/getPointSizeByEntryRadius';
import {
	buildPointEntryRadiusIconRelativeSingleVoyage
} from "@containers/singleVoyage/containers/points/icon/buildPointIcon";

import {
	getPointLabelKeyStatusSingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/getPointStatusLabelKey";
import {useTranslation} from 'react-i18next';
import PointInfoViewSingleVoyage
	from "@containers/singleVoyage/containers/points/views/pointInfo/PointInfoViewSingleVoyage";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";

interface IProps {
	point: Omit<IWayPointCreationSingleVoyage, 'waypointTemplateId'> & {
		waypointTemplateId?:number | null
	},
	zoomLevel: number,
}

const PointTrackRadiusMarkerSingleVoyage = ({
												point,
												zoomLevel
											}: IProps) => {
	
	const {t} = useTranslation()
	
	const entryRadiusSize = useMemo(() => {
		if (!point?.radius || !zoomLevel) {
			return 0
		}
		return getPointSizeByEntryRadiusSingleVoyage({
			entryRadius: point?.radius,
			zoomLevel
		})
	}, [point, zoomLevel])
	
	const icon = useMemo(() => {
		return new DivIcon({
			html: buildPointEntryRadiusIconRelativeSingleVoyage(entryRadiusSize),
			iconSize: [entryRadiusSize, entryRadiusSize],
			popupAnchor: [0, -40],
		})
	}, [point, entryRadiusSize])
	
	const {lat, lng} = getLatLngFromPointGeomCoordinates(point.geom)
	return (
		<LeafletMarker
			key={'targetIcon'}
			icon={icon}
			position={new LatLng(lat, lng)}
		>
			<LeafletPopup>
				<PointInfoViewSingleVoyage
					address={point?.address}
					name={point?.name}
					plannedStayStart={point?.plannedDeparture}
					plannedStayEnd={point?.plannedArrival}
					entryRadius={point?.radius}
					status={t(getPointLabelKeyStatusSingleVoyage(point.status))}
					type={point.type}
					isTemplatePoint={!!point.waypointTemplateId}
				/>
			</LeafletPopup>
		</LeafletMarker>
	);
};

export default PointTrackRadiusMarkerSingleVoyage;
